import { ApiUtil as api } from "@/utils/api.util.js";

export class PortalService {
  static URL = process.env.API_URL + process.env.API_VER;
  static RESOURCE = "/portals/";

  static all(queryParams = {}) {
    return api.get(this.URL + this.RESOURCE, queryParams);
  }

  static store (data = {}) {
    return api.post(this.URL + this.RESOURCE, data)
  }

  static update (id, data = {}) {
    return api.post(this.URL + this.RESOURCE + id, data)
  }

  static find (data = {}) {
    return api.get(this.URL + this.RESOURCE + 'find', data)
  }

}



// WEBPACK FOOTER //
// ./src/services/portal.service.js